import React from 'react'
import PropTypes from 'prop-types'

/**
 * Table head component
 */
const TableHead = ({ className = '', children, ...props }) => (
  <thead className={className} {...props}>
    {children}
  </thead>
)

TableHead.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

TableHead.defaultProps = {
  className: ''
}

export default TableHead
